﻿const sortBySortOrder = (dataMap, children) => {
	children.forEach((id) => {
		const { children } = dataMap.get(id);
		if (children?.length) {
			sortBySortOrder(dataMap, children);
		}
	});

	children.sort((firstKey, secondKey) => {
		const firstItem = dataMap.get(firstKey);
		const secondItem = dataMap.get(secondKey);

		return firstItem.sort_order - secondItem.sort_order;
	});
};

export const createNavDataStore = (data) => {
	const roots = new Set();
	const dataMap = new Map();
	const tocItems = [];
	data.forEach((item, id) => {
		if (item['@odata.type'] !== '#CommandBarSectionItem') {
			dataMap.set(id, item);
			return;
		}

		const { related_id: relatedId } = item;
		const relatedItem = data.get(relatedId);
		const { 'parent_menu@aras.id': parentId } = relatedItem;
		if (!parentId) {
			roots.add(id);
		}

		const tocItem = {
			...item
		};
		if (relatedItem['@odata.type'] === '#CommandBarMenu') {
			tocItem.children = [];
		}

		tocItems.push(tocItem);
		dataMap.set(id, tocItem);
	});

	tocItems.forEach((item) => {
		const relatedItem = dataMap.get(item.related_id);
		const parentId = relatedItem['parent_menu@aras.id'];
		if (!parentId) {
			return;
		}

		const childId = item.id;
		tocItems
			.filter(({ related_id: relatedId, children }) => {
				return relatedId === parentId && !children.includes(parentId);
			})
			.forEach((item) => {
				item.children.push(childId);
			});
	});

	return { roots, dataMap };
};

export const applyNavChanges = (nav, data) => {
	const dataStore = createNavDataStore(data);
	const { dataMap, roots } = dataStore;
	const rootsArr = [...roots];
	sortBySortOrder(dataMap, rootsArr);
	nav.dataStore.items = dataMap;
	nav.dataStore.roots = new Set(rootsArr);
	return nav.render();
};
